export var defaultFilterItems = function defaultFilterItems(items, _ref) {
  var itemToString = _ref.itemToString,
      inputValue = _ref.inputValue;
  return items.filter(function (item) {
    if (!inputValue) {
      return true;
    }

    return itemToString(item).toLowerCase().includes(inputValue.toLowerCase());
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/ComboBox/tools/filter.js
// module id = 666
// module chunks = 15